export const kibanaRouteName = 'dashboard.osd';
// Pre-OSD alias kept alive for links minted before the OSD migration (scheduled-report Slack/email
// links are still built with it server-side). It only redirects to `kibanaRouteName`.
export const legacyKibanaRouteName = 'dashboard.kibana';
export const kibanaViewUrlPrefix = '/dashboard/osd';
export const kibanaResourceParamName = 'resource';
